import { render, staticRenderFns } from "./BannersGrid.vue?vue&type=template&id=48a28728&scoped=true"
import script from "./BannersGrid.vue?vue&type=script&lang=ts"
export * from "./BannersGrid.vue?vue&type=script&lang=ts"
import style0 from "./BannersGrid.vue?vue&type=style&index=0&id=48a28728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a28728",
  null
  
)

export default component.exports